import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageTitle} from '../../../../_metronic/layout/core'
import {JobsListWrapper} from './jobs-list/JobsList'
import JobEditor from './JobEditor'

const JobsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='list/*'
          element={
            <>
              <PageTitle>Job Listings</PageTitle>
              <JobsListWrapper />
            </>
          }
        />
        <Route path='new' element={<JobEditor />} />
        <Route path='edit/:id' element={<JobEditor />} />
        <Route index element={<Navigate to='/jobs/list' />} />
      </Route>
    </Routes>
  )
}

export default JobsPage
